// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { Plugin, QCProgram } from '@tls/sw91_ui_templates/lib/models/project-models';
import type { TFunction } from 'i18next';

export function getAlgorithmResultName(
  path: string | undefined,
  qcpProject: QCProgram | undefined,
  plugins: Plugin[],
  t: TFunction
): string {
  if (!path) return '—';

  const [, algorithmName, , area, parameterName] = path.split('.');
  const algorithmCall = qcpProject?.instructions.stages.stage_03_calling_algorithms.algorithm_calls.find(
    call => call.name === algorithmName
  );
  const plugin =
    algorithmCall &&
    plugins.find(
      item =>
        item.plugin_name === algorithmCall.algorithm.plugin_name &&
        item.plugin_namespace === algorithmCall.algorithm.plugin_namespace
    );
  const parameter = plugin?.output[area as keyof Plugin['output']]?.find(item => item.name === parameterName);
  const key = parameter?.label?.translation_key;
  const translated = key ? t(key, { ns: 'algorithm', defaultValue: parameterName }) : parameterName;
  const label = typeof translated === 'string' && translated.trim() ? translated : parameterName;

  return `${algorithmName}: ${label}`;
}
